import React from 'react';

export default {
  en: {
    title: 'Crossing through CBX offers several advantages to passengers traveling through the Tijuana International Airport:',
    description: [
      <ul>
        <li>
          Access to 40 destinations including cities such as Mexico City,
          Guadalajara, Monterrey, Querétaro, Puebla, Zacatecas,
          Morelia and beach destinations such as La Paz,
          San José del Cabo, Puerto Vallarta, Puerto Escondido,
          Cancun, Ixtapa, Loreto, among many others.
        </li>
        <li>
          Extensive connectivity through 4 commercial airlines; Aeroméxico, Calafia,
          Viva Aerobus and Volaris which operate routes to and from the Tijuana
          International Airport with a monthly average of 6000 flights.
        </li>
        <li>
          Savings of up to 50% on airfares to Mexican destinations compared to flights
          from other Southern California airports.
        </li>
        <li>
          A fast, easy and safe border crossing, without having to leave the Tijuana
          International Airport, making it a practical alternative to crossing through
          the traditional port of entries.
        </li>
        <li>
          Technology and innovation that makes the crossing process between Mexico
          and the United States a unique and modern experience, including the possibility
          of making your travel touchless, with the safety and well-being of passengers
          as a key priority.
        </li>
        <li>
          An airport terminal designed by the Legorreta architectural firm that offers a
          warm atmosphere to passengers, wide open spaces and access to an array of services
          such as airline counters, shuttle service, car rentals, Starbucks, Wetzel&apos;s Pretzels,
          food truck area and currency exchange.
        </li>
      </ul>],
    tip: 'For more details, visit the ',
    tiptext: 'Services page',
    tiplink: '/en/services',
    countrylang: 'United States',
    imgsmall: 'https://cbx-fe.s3.us-east-2.amazonaws.com/api-uploads/CBX-MAPA-40-destinos-julio-2023-ENG.png',
    imglarge: 'https://cbx-fe.s3.us-east-2.amazonaws.com/api-uploads/CBX-MAPA-40-destinos-julio-2023-ENG.png'
  },
  es: {
    title: 'Cruzar por CBX ofrece varias ventajas a los pasajeros que viajan a través del Aeropuerto Internacional de Tijuana:',
    description: [
      <ul>
        <li>
          Acceso a 40 destinos incluyendo ciudades como Ciudad de México, Guadalajara,
          Monterrey, Querétaro, Puebla, Zacatecas, Morelia y destinos de playa como La Paz,
          San José del Cabo, Puerto Vallarta, Puerto Escondido, Cancún, Ixtapa, Loreto, entre muchos otros.
        </li>
        <li>
          Amplia conectividad a través de 4 aerolíneas comerciales; Aeroméxico, Calafia,
          Viva Aerobus y Volaris que operan rutas desde y hacia el Aeropuerto Internacional de
          Tijuana con un promedio mensual de 6000 vuelos.
        </li>
        <li>
          Ahorro de hasta un 50% en tarifas aéreas hacia destinos mexicanos en comparación con
          vuelos desde otros aeropuertos del sur de California.
        </li>
        <li>
          Un cruce fronterizo ágil, cómodo y seguro, sin necesidad de salir del Aeropuerto
          Internacional de Tijuana, que constituye una alternativa práctica al cruce por las
          garitas convencionales de San Ysidro y Mesa de Otay.
        </li>
        <li>
          Tecnología e innovación que hacen del proceso de cruce entre México y Estados Unidos
          una experiencia única e inteligente, incluso con la posibilidad de hacerla libre de
          contacto, teniendo como prioridad la seguridad y bienestar de los pasajeros.
        </li>
        <li>
          Una terminal aeroportuaria diseñada por el despacho arquitectónico Legorreta que ofrece
          una atmósfera cálida a los pasajeros, espacios amplios y servicios complementarios para
          su viaje; entre ellos, mostradores de aerolíneas, servicio de shuttle, arrendadoras de
          auto, Starbucks, Wetzel´s Pretzels, área de food trucks y casa de cambio.
        </li>
      </ul>],
    tip: 'Para conocer más detalles, visita la ',
    tiptext: 'página de servicios',
    tiplink: '/es/services',
    countrylang: 'Estados Unidos',
    imgsmall: 'https://cbx-fe.s3.us-east-2.amazonaws.com/api-uploads/CBX-MAPA-40-destinos-julio-2023-ESP.png',
    imglarge: 'https://cbx-fe.s3.us-east-2.amazonaws.com/api-uploads/CBX-MAPA-40-destinos-julio-2023-ESP.png'
  },
};
